module.exports = __webpack_public_path__ + "img/create-a-report.9bad16bd.jpg";